import isEmpty from 'lodash.isempty'
import getOptions from '@/api/options.wp.api'

const state = {
	settings: {
		currentLang: '',
		altLangLinks: {
			'de-ch': '',
			'en-us': ''
		}
	},
	siteSettings: {
		'de-ch': {},
		'en-us': {}
	},
	clients: {
		'de-ch': [],
		'en-us': []
	}
};

const actions = {
	setCurrentLanguage: ({ commit }, payload) => {
		commit('UPDATE_CURRENT_LANGUAGE', payload);
	},
	setAltLanguageLink: ({ commit }, payload) => {
		commit('UPDATE_ALT_LANGUAGE_LINK', payload);
	},
	loadACFOptionsPage: ({ commit, state }, payload) => {
		if (isEmpty(state.siteSettings[state.settings.currentLang]) || !state.clients[state.settings.currentLang].length) {
			getOptions(state.settings.currentLang).then(response => {
				commit('SITE_SETTINGS_SAVE', response.data)
				commit('CLIENTS_SAVE', response.data.clients_repeater)
			})
		}
	}
};

const mutations = {
	UPDATE_CURRENT_LANGUAGE: (state, payload) => {
		state.settings.currentLang = payload;
	},
	UPDATE_ALT_LANGUAGE_LINK: (state, data) => {
		state.settings.altLangLinks[data.lang] = data.link;
	},
	SITE_SETTINGS_SAVE: (state, payload) => {
		state.siteSettings[state.settings.currentLang] = payload;
	},
	CLIENTS_SAVE: (state, payload) => {
		state.clients[state.settings.currentLang] = payload;
	}
};

const getters = {
};

export default {
	state,
	actions,
	mutations,
	getters
};



// WEBPACK FOOTER //
// ./src/vuex/modules/general.store.js